import { Permissions } from 'components/permissions';
import {
    AccountMemberPermission,
    AccountPermission,
    ImportPermission,
} from 'components/permissions/PermissionEnums';
import * as SubNav from 'components/sub-nav';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const SettingsSubNavTabs = () => {
    const { accountId } = useCurrentAccount();

    return (
        <SubNav.Tabs>
            <SubNav.TabItem
                to={`/accounts/${accountId}/settings/about`}
                data-testid={TestIds.AccountSettings.About.Profile}
            >
                About
            </SubNav.TabItem>
            <Permissions allowed={[AccountPermission.VIEW, AccountPermission.SETTINGS]}>
                <SubNav.TabItem
                    to={`/accounts/${accountId}/settings/settings`}
                    data-testid={TestIds.AccountSettings.Account.General}
                >
                    Account
                </SubNav.TabItem>
            </Permissions>
            <Permissions allowed={[AccountPermission.INTEGRATIONS]}>
                <SubNav.TabItem
                    to={`/accounts/${accountId}/settings/integrations`}
                    data-testid={TestIds.AccountSettings.Integrations.ThirdParty}
                >
                    Integrations
                </SubNav.TabItem>
            </Permissions>
            <Permissions allowed={[AccountMemberPermission.VIEW]}>
                <SubNav.TabItem
                    to={`/accounts/${accountId}/settings/users`}
                    data-testid={TestIds.AccountSettings.Users}
                >
                    Users
                </SubNav.TabItem>
            </Permissions>
            <Permissions allowed={[ImportPermission.VIEW]}>
                <SubNav.TabItem
                    to={`/accounts/${accountId}/settings/imports`}
                    data-intercom-target={IntercomProductTourTargets.SettingsImportsSubnavTab}
                    data-testid={TestIds.AccountSettings.Imports.History}
                >
                    Imports
                </SubNav.TabItem>
            </Permissions>
        </SubNav.Tabs>
    );
};

export { SettingsSubNavTabs };
